export class CompanyGroupInfo {
  CompanyGroupID: number
  CompanyGroupTypeCode: string
  CompanyGroupTypeName: string
  CompanyGroupCode: string
  CompanyGroupName: string
  CompanyGroupDesc: string
  CompanyGroupCreateDate: string
  CompanyGroupCreateBy: string
  CompanyGroupUpdateDate: string
  CompanyGroupUpdateBy: string
  CompanyGroupFlagDelete: string
  rowOFFSet: number
  rowFetch: number
  itemTotal: number
}
